export const tableBreak = {
  tiny: '(max-width: 410px)',
  small: '(max-width: 550px)',
  medium: '(max-width: 1070px)',
  large: '(max-width: 1255px)',
  huge: '(max-width: 1780px)',
}
